export const GIT_COMMIT = '8a3ff4e3ed75cada1828c8ec747d859eaa7e9f77'
